import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

export const BodyText = React.forwardRef<HTMLSpanElement, TypographyProps<'span', { children: React.ReactNode }>>(
  ({ children, ...properties }, reference) => {
    return (
      <Typography ref={reference} variant='body2' component='span' data-testid='body-text' {...properties}>
        {children}
      </Typography>
    );
  }
);

BodyText.displayName = 'BodyText';
